import { Component } from '@angular/core';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item.component-two';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports: [CommonModule, RouterModule, DropdownComponent, DropdownItemTwoComponent]
})
export class UserDropdownComponent {
  isOpen = false;
  isLoading = false;
  errorMessage = '';

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  signout() {
    console.log("signout click ")

    // this.authService.signIn().subscribe({
    //   next: (response) => {
    //     this.isLoading = false;
    //     console.log(response, "response")

    //     console.log('Login success:', response);

    //     // Save token
    //     localStorage.setItem('token', response.data.token);

    //     // Navigate to dashboard
    //     this.router.navigate(['/']);
    //   },
    //   error: (error) => {
    //     this.isLoading = false;
    //     this.errorMessage = error?.error?.message || 'Login failed';
    //     console.error('Login error:', error);
    //   }
    // });
    localStorage.removeItem('token');
    // Navigate to SignIn
    this.router.navigate(['/signin']);
  }
}